/**
 * Formats a decimal value as a percentage string
 * @param value - The decimal value (e.g., 0.5 for 50%, 1.0 for 100%)
 * @param decimals - Number of decimal places to show (default: 0)
 * @returns Formatted percentage string (e.g., "50%", "100%")
 */
export const formatPercentage = (value: number, decimals: number = 0): string => {
  const percentage = value * 100;
  return `${percentage.toFixed(decimals)}%`;
};

/**
 * Formats a value already in percent-space (e.g. 48.2759 for 48.2759%) rather than the 0-1
 * fraction formatPercentage expects.
 * @param value - The percent value (e.g. 48.2759 for "48.28%")
 * @param decimals - Number of decimal places to show (default: 2)
 * @returns Formatted percentage string (e.g. "48.28%")
 */
export const formatPercentPoints = (value: number, decimals: number = 2): string =>
  formatPercentage(value / 100, decimals);
